import { ConfigProvider as AntDProvider } from 'antd'
import { EmptyCP } from 'main/common/components/empty/EmptyCP'
import { LoadingOverlayCP } from 'main/common/components/loading/loading-overlay/LoadingOverlayCP'
import { ReduxHelper } from 'main/common/redux/helpers/ReduxHelper'
import { ITheme } from 'main/config/theme/ITheme'
import { ThemeProvider } from 'main/config/theme/styledWithTheme'
import { ThemeAnt } from 'config/theme/ant/ThemeAnt'
import { AppInitializerCP } from 'main/modules/app/components/app/inner/AppInitializerCP'
import React from 'react'
import { Provider as ReduxProvider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import './inner/ajustes-globais.css'

/**
 */
export function App(): JSX.Element {

    return (
        <ReduxProvider store={ReduxHelper.getInstance().store}>
            <PersistGate loading={<LoadingOverlayCP show={true}/>} persistor={ReduxHelper.getInstance().persistor}>
                <AntDProvider renderEmpty={() => <EmptyCP/>}>
                    <ThemeProvider theme={ThemeAnt as ITheme}>
                        <BrowserRouter>

                            <AppInitializerCP/>

                        </BrowserRouter>
                    </ThemeProvider>
                </AntDProvider>
            </PersistGate>
        </ReduxProvider>
    )
}
